jQuery(document).ready(function($) {

  $(window).on('resize', function() {
    var ratio = $(window).width() / $(window).height()
    // $('h1').html(ratio)
    if (ratio > 1.6) {
      $('body').addClass('short')
    } else {
      $('body').removeClass('short')
    }
  }).trigger('resize')

  // description toggles
  $('.description h2, .description p.close').on('click', function() {
    var $carouselCell = $(this).closest('.carousel-cell')
    $carouselCell.find('.dot').first().trigger('click')
    $carouselCell.removeClass('showing-full').toggleClass('showing-description')
    $('body').toggleClass('carousel-description--is-showing')
    $('.pane').removeClass('caption--is-showing')
  })

  $('.flip-card-container').on('click', function() {
    var $carouselCell = $(this).closest('.carousel-cell')
    if ($carouselCell.hasClass('showing-description') == false) {
      var $pane = $(this).closest('.pane')
      $pane.toggleClass('caption--is-showing')
    }
  })

  $('.dots .dot').on('click', function() {
    var $dot = $(this)
    var dotIndex = $dot.index()
    var $setsDots = $dot.closest('.sets-dots')
    var $sets = $setsDots.find('.sets')
    var $dots = $setsDots.find('.dots')
    $sets.find('.set').removeClass('set--is-showing').eq(dotIndex).addClass('set--is-showing')
    $dots.find('.dot').removeClass('dot--is-active').eq(dotIndex).addClass('dot--is-active')
  })

  // carousel
  var initialIndex = 0
  if (getParameterByName('product-id')) {
    if (Foundation.MediaQuery.current == 'small') {
      window.location = '/product-details/?product-id=' + getParameterByName('product-id')
    } else {
      initialIndex = $('.carousel-cell[data-product-id="' + getParameterByName('product-id') + '"]').index()
    }
  }
  var $carousel = $('.carousel').flickity({
    cellSelector: '.carousel-cell',
    contain: true,
    pageDots: false,
    prevNextButtons: true,
    percentPosition: false,
    autoPlay: 0,
    imagesLoaded: true,
    fade: true,
    setGallerySize: false,
    resize: true,
    draggable: false,
    wrapAround: true,
    initialIndex: initialIndex
  })

  $('.controls .flip').on('click', function() {
    var $pane = $(this).closest('.pane')
    $pane.find('.flip-card').toggleClass('flipped')
    $pane.find('.caption').removeClass('caption--is-showing')
  })

  function getParameterByName(name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[\[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

})
